import styles from './visual-header.module.scss';
import { memo } from 'react';
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import {useState} from 'react';

interface VisualHeaderProps {
  backgroundImage: string;
  active: boolean;
  location: "left" | "right";
  caption?: {
    header?: string;
    text?: string
  }
  imagePosition?: { x: string, y: string }
}

export const VisualHeader = memo(({ backgroundImage, active, location, caption, imagePosition }: VisualHeaderProps) => {
  const [hide] = useState(false);

  return (<Transition in={active} appear={true} timeout={0} unmountOnExit={false}>
    {state => <div 
      className={cn(styles.visualHeader, styles[location], styles.animate, styles[`state-${state}`], { [styles.hide]: hide })} 
      style={{backgroundImage: `url(${backgroundImage})`, backgroundPosition: imagePosition ? `${imagePosition.x} ${imagePosition.y}` : "center" }}
    >
      {caption && <div className={styles.caption}>
        <h2 className={styles.captionHeader}>{caption.header}</h2>
        <p className={styles.captionText}>{caption.text}</p>
      </div>}
    </div>}
  </Transition>)
});